import { InjectableHook } from 'domain/types/InjectableHook';
import { RequestReportParams, ReportData } from 'domain/entities/Report';

export const ReportRepository = Symbol('ReportRepository');

export type ReportRepository = InjectableHook<{
  getReports(params: RequestReportParams): Promise<ReportData>;
}>;
